<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">

      <div class="xblock layui-form">
        <div class="layui-input-inline country_select xblock-row">
          <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
            <option value="0">全部</option>
            <option :value="item.id" v-text="item.name" v-for="(item,index) in status" v-bind:key="index"></option>
          </select>
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="用户ID搜索" v-on:keydown.13="get_recharge_record(true)"
            v-model="uid" autocomplete="off" class="layui-input" />
        </div>
        <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="get_recharge_record(true)"><i
            class="fa fa-search"></i></button>
        <div class="x-right xblock-row">
          <span class="x-right" v-text="'　共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'总额：'+money+ '元　|'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>流水号</th>
            <th>用户</th>
            <th>手机号</th>
            <th>状态</th>
            <th>金额</th>
            <th>积分</th>
            <th>当前积分</th>
            <th>时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index"
            :class="[{cancel_box:item.status == 1},{shipping_box:item.status == 2}]">
            <td v-text="item.id"></td>
            <td v-text="item.uid"></td>
            <td v-text="item.phone"></td>
            <td>
              <i v-if="item.status == 1">未完成</i>
              <i v-else>已完成</i>
            </td>
            <td v-text="item.money"></td>
            <td v-text="item.integral"></td>
            <td v-text="item.last_money"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition v-if="list.length < 1"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage, laydate;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'MemberRechargeLog',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        uid: null,
        page: 1,
        count: 0,
        money: 0,
        page_num: 20,
        current_status: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "未完成"
        }, {
          id: 2,
          name: "已完成"
        }],
        printObj: {
          id: "prinst", // 这里是要打印元素的ID
          popTitle: '	', // 打印的标题
          extraCss: '', // 打印可引入外部的一个 css 文件
          extraHead: '', // 打印头部文字
        }
      }
    },
    mounted() {
      self = this;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {

        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          trigger: 'click',
          done: function(value, date, endDate) {
            $("#order_date").val(value);
            self.get_recharge_record()
          }
        });

        form.on('select(status_selection)', function(data) {
          self.current_status = data.value;
          self.get_recharge_record(true)
        });
        form.render('select');

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record(etype) {
        if (etype) {
          self.page = 1;
          self.list = [];
        }
        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }
        if (self.uid) {
          param.append('uid', self.uid)
        }

        param.append('status', self.current_status)
        axios({
          method: 'post',
          data: param,
          url: self.GetServerUrl() + "/recharge_record_all/?page=" + self.page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.count = datas.page.count;
            self.list = datas.list;
            self.money = datas.money;
            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();
          }, false);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .total-data {
    padding: 12px 10px;
    line-height: 18px;
  }

  .total-data-row {
    color: #444;
    padding-right: 30px;
    margin-right: 30px;
    border-right: 1px solid #CCC;
    font-family: Microsoft YaHei, arial;
    font-family: arial;
    font-size: 15px;
  }

  .total-data-row:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/logistics/MemberRechargeLog.vue